module.exports = __webpack_public_path__ + "img/banner_text_1.173d1fa9.png";